import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomeShowAllCusReq from "./Components/HomeShowAllCusReq";
import HomeShowAllCustomer from "./Components/HomeShowAllCustomer";
import HomeShowAllMembers from "./Components/HomeShowAllMembers";
import {
  fetchUsers,
  fetchMembers,
  fetchComplaints,
} from "../../Redux/Slice/Homepage";
import "../CustomerReq/InhouseRnd.css";
import {
  Calendar,
  Clock,
  Building2,
  Users,
  FileText,
  LayoutGrid,
} from "lucide-react";

const Home = () => {
  const dispatch = useDispatch();
  const [currentTime, setCurrentTime] = useState(new Date());

  const [activeSection, setActiveSection] = useState(() => {
    return sessionStorage.getItem("home_active_section") || "customers";
  });

  const { data, membersData, complaintsData } = useSelector(
    (state) => state.Home
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchMembers());
    dispatch(fetchComplaints());
  }, [dispatch]);

  useEffect(() => {
    sessionStorage.setItem("home_active_section", activeSection);
  }, [activeSection]);

  const customerCount = data?.data?.length || 0;
  const membersCount = Array.isArray(membersData?.data)
    ? membersData.data.length
    : 0;
  const complaintsCount = complaintsData?.data?.length || 0;

  return (
    <div className="w-full flex flex-col space-y-3.5 py-2">
      {/* Top Header Banner with Live Clock */}
      <div className="page-header-banner-compact">
        <div>
          <h4>Dashboard Overview</h4>
          <span className="page-subtitle">
            Customer directory, active team members, and live support requests
          </span>
        </div>

        {/* Live Date & Time Clock */}
        <div className="dashboard-live-clock">
          <span className="clock-date">
            <Calendar size={13} className="text-slate-500" />
            {currentTime.toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </span>
          <span className="clock-divider"></span>
          <span className="clock-time">
            <Clock size={13} className="text-[#133A69]" />
            {currentTime.toLocaleTimeString("en-IN", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </span>
          <span className="live-dot" title="Live clock"></span>
        </div>
      </div>

      {/* 🔘 Top Navigation Buttons (Show All Customer / Show All Members / Show All Customer Request) */}
      <div className="home-nav-container">
        <div className="home-nav-group">
          {/* Button 1: Show All Customer */}
          <button
            type="button"
            onClick={() => setActiveSection("customers")}
            className={`home-nav-btn ${
              activeSection === "customers" ? "active" : ""
            }`}
          >
            <span className="home-nav-btn-icon home-nav-icon-customer">
              <Building2 size={13} />
            </span>
            <span>Show All Customer</span>
            <span className="home-nav-badge">{customerCount}</span>
          </button>

          {/* Button 2: Show All Members */}
          <button
            type="button"
            onClick={() => setActiveSection("members")}
            className={`home-nav-btn ${
              activeSection === "members" ? "active" : ""
            }`}
          >
            <span className="home-nav-btn-icon home-nav-icon-member">
              <Users size={13} />
            </span>
            <span>Show All Members</span>
            <span className="home-nav-badge">{membersCount}</span>
          </button>

          {/* Button 3: Show All Customer Request */}
          <button
            type="button"
            onClick={() => setActiveSection("requests")}
            className={`home-nav-btn ${
              activeSection === "requests" ? "active" : ""
            }`}
          >
            <span className="home-nav-btn-icon home-nav-icon-request">
              <FileText size={13} />
            </span>
            <span>Show All Customer Request</span>
            <span className="home-nav-badge">{complaintsCount}</span>
          </button>
        </div>

        {/* View All Sections Toggle */}
        <button
          type="button"
          onClick={() => setActiveSection("all")}
          className={`home-nav-viewall-btn ${
            activeSection === "all" ? "active" : ""
          }`}
          title="Display all three sections together"
        >
          <LayoutGrid size={13} />
          <span>View All Sections</span>
        </button>
      </div>

      {/* Sections Rendering */}
      <div className="w-full space-y-4">
        {(activeSection === "customers" || activeSection === "all") && (
          <HomeShowAllCustomer />
        )}

        {(activeSection === "members" || activeSection === "all") && (
          <HomeShowAllMembers />
        )}

        {(activeSection === "requests" || activeSection === "all") && (
          <HomeShowAllCusReq />
        )}
      </div>
    </div>
  );
};

export default Home;
